export const COURIER_ERROR_TYPES = [
  { label: 'Package left outside package room' },
  { label: 'Package left outside building' },
  { label: 'Incorrect recipient info' },
  { label: 'Other' },
];
